import React from 'react'
import PropTypes from 'prop-types'

// A panel with the page's dark header strip: title on the left, a count or other aside on the right.
const ResultsCard = ({ title, subtitle, isLive = false, children }) => (
  <div className="gl-event-results-card">
    <div className="gl-event-results-dark-card-hd">
      {/* h2, so the page has a heading outline; the sass zeroes its margin. */}
      <h2 className="gl-event-results-dark-card-title">
        {isLive && <span className="gl-event-results-live-dot-sm" aria-hidden="true"/>}
        {title}
      </h2>
      {subtitle && <div className="gl-event-results-dark-card-sub">{subtitle}</div>}
    </div>
    {children}
  </div>
)

ResultsCard.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  isLive: PropTypes.bool,
  children: PropTypes.node,
}

export default ResultsCard
